import api from './axiosConfig';

export interface AccountKPIs {
  totalAccounts: number;
  systemAdminAccounts: number;
  recentRegisteredAccounts: number;
  recentSeenAccounts: number;
  loginAttempts: { date: string; count: number }[];
  accountLogs: { date: string; count: number }[];
}

const getAccountKPIs = async (): Promise<AccountKPIs> => {
  try {
    const response = await api.get('accountKPIs');
    return response.data;
  } catch (error) {
    console.error('Error fetching account KPIs:', error);
    throw error;
  }
};

export const AccountKPIsService = {
  getAccountKPIs
};
